import { render, staticRenderFns } from "./MailModal.vue?vue&type=template&id=363675dc&"
import script from "./MailModal.vue?vue&type=script&lang=js&"
export * from "./MailModal.vue?vue&type=script&lang=js&"
import style0 from "./MailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports